import {
  DecisionTreeNodeDataFrontChat,
  isDecisionTreeBranchNodeDataFrontChat,
  NodeDataFrontChatTypesEnum,
} from '../../../../libs/shared/core/src/models/api/decisionTreeNodeDataModel';
import {nodeSpacingFromDirection} from '../../../../libs/shared/ui/src/components/decisionTrees/decisionTreeBuilder/helpers';
import {LayoutOptions} from '../../../../libs/shared/ui/src/components/decisionTrees/decisionTreeBuilder/hooks/useReactFlowLayout';
import {DecisionTreeBuilderDirectionsEnum} from '../../../../libs/shared/ui/src/components/decisionTrees/decisionTreeBuilder/types';

/*
 * Constants.
 */

/**
 * The direction that the tree grows.
 */
export const chatBotBuilderDirection: DecisionTreeBuilderDirectionsEnum =
  DecisionTreeBuilderDirectionsEnum.LEFT_TO_RIGHT;

export const chatBotBuilderLayoutOptions: LayoutOptions<DecisionTreeNodeDataFrontChat> = {
  direction: chatBotBuilderDirection,
  computeNodeSize: (data: DecisionTreeNodeDataFrontChat): [number, number] => {
    const nodeSpacing = nodeSpacingFromDirection(chatBotBuilderDirection);

    // We halve the spacing from the start node for overall visual consistency with other nodes.
    if (data.type === NodeDataFrontChatTypesEnum.START) {
      return [nodeSpacing[0] / 2, nodeSpacing[1] / 2];
    }

    // Multi Choice nodes have their vertical distance increased with respect to the number of options.
    if (isDecisionTreeBranchNodeDataFrontChat(data)) {
      const spacingMultiplier = 1 + data.options.length * 0.2;
      return [nodeSpacing[0] * spacingMultiplier, nodeSpacing[1]];
    }

    // Custom Field nodes have their vertical distance doubled, due to the larger maximum height.
    if (data.type === NodeDataFrontChatTypesEnum.CUSTOM_FIELDS) {
      return [nodeSpacing[0] * 2, nodeSpacing[1]];
    }

    return nodeSpacing;
  },
};

// NOTE: For now this includes the START and END node, but once pricing plans come into play we may need to omit them.
export const maxChatBotNodesCount = 500;

export const multiChoiceMinOptions = 2;
export const multiChoiceMaxOptions = 8;
export const parseMinOptions = 1;
export const parseMaxOptions = 7;

export const parseTextMaxKeywordSetSize = 60;

// Max number of CUSTOM_FIELDS node fields that legacy growth plans & premium plans have access to.
export const customFieldPremiumFeaturesMaxOptions = 3;
// Max number of CUSTOM_FIELDS node fields that all other plans have access to.
export const customFieldBasicFeaturesMaxOptions = 2;

export const maxMessageContentLength = 5000;
export const maxPromptContentLength = 5000;
